import { render } from "./StaffManagement.vue?vue&type=template&id=477c8d3e&scoped=true"
import script from "./StaffManagement.vue?vue&type=script&lang=js"
export * from "./StaffManagement.vue?vue&type=script&lang=js"

import "./StaffManagement.vue?vue&type=style&index=0&id=477c8d3e&lang=css"
import "./StaffManagement.vue?vue&type=style&index=1&id=477c8d3e&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477c8d3e"]])

export default __exports__